import React, { Fragment, useRef } from 'react';
import { Helmet } from 'react-helmet';

import HeaderV2 from '../../components/headerV2/HeaderV2';
import FooterV2 from '../../components/footerV2/FooterV2';
import AboutHero from '../../components/aboutHero/AboutHero';
import useScrollReveal from '../../hooks/useScrollReveal';

import './galleryV2.css';

/* Common chrome for every gallery demo page: Helmet (with the Anton/Inter
   fonts the jjfv2 headings need), HeaderV2, hero, centered heading, footer.
   The heading sits in a .wrap; `children` render directly in the section so
   each demo can be constrained (.wrap) or full-bleed as it likes. */
const GalleryDemoLayout = ({ demoLabel, kicker, title, lead, children }) => {
    const rootRef = useRef(null);
    useScrollReveal(rootRef);

    return (
        <Fragment>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                    rel="stylesheet"
                />
                <title>{`Gallery ${demoLabel} — Blood Donation | JJF India`}</title>
                <meta name="description" content="Gallery layout demo for JJF India's blood donation drives." />
            </Helmet>

            <div className="jjfv2 gallery-live" ref={rootRef}>
                <HeaderV2 />

                <main className="page_content">
                    <AboutHero
                        eyebrow={`Gallery · ${demoLabel}`}
                        title="Blood Donation"
                        crumbs={[
                            { label: 'Home', to: '/' },
                            { label: 'Gallery' },
                            { label: demoLabel },
                        ]}
                    />

                    <section className="section">
                        <div className="wrap">
                            <div className="gal-head">
                                <span className="eyebrow">{kicker}</span>
                                <h2>{title}</h2>
                                {lead && <p>{lead}</p>}
                            </div>
                        </div>
                        {children}
                    </section>
                </main>

                <FooterV2 />
            </div>
        </Fragment>
    );
};

export default GalleryDemoLayout;
